import * as fromDatatype from "../datatype-library/index";


export interface bl_wms_pick_pack_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    qty_balance: fromDatatype.NumericDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    base_qty: fromDatatype.NumericDatatypeInterface;
    priority: fromDatatype.NumericDatatypeInterface;
    queue_type: fromDatatype.VarcharDatatypeInterface;
    running_number: fromDatatype.VarcharDatatypeInterface;
    machine_guid: fromDatatype.GuidDataFieldInterface;
    awaiting_approval: fromDatatype.NumericDatatypeInterface;
    entity_branch_code: fromDatatype.VarcharDatatypeInterface;
    entity_branch_guid: fromDatatype.GuidDataFieldInterface;
}


export class bl_wms_pick_pack_queue_RowClass implements bl_wms_pick_pack_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    qty_balance: fromDatatype.NumericDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    base_qty: fromDatatype.NumericDatatypeInterface;
    priority: fromDatatype.NumericDatatypeInterface;
    queue_type: fromDatatype.VarcharDatatypeInterface;
    running_number: fromDatatype.VarcharDatatypeInterface;
    machine_guid: fromDatatype.GuidDataFieldInterface;
    awaiting_approval: fromDatatype.NumericDatatypeInterface;
    entity_branch_code: fromDatatype.VarcharDatatypeInterface;
    entity_branch_guid: fromDatatype.GuidDataFieldInterface;
}